import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const questionsRoutes: Routes = [
  {
    title: 'pagesTitles.questions',
    path: APP_ROUTES.QUESTIONS,
    canActivate: [permissionGuard(APP_PERMISSIONS.QuestionsRead)],
    loadComponent: () =>
      import('./pages/list-question').then((m) => m.ListQuestion),
  },
  {
    title: 'pagesTitles.questionCreate',
    path: APP_ROUTES.QUESTIONS_NEW,
    canActivate: [permissionGuard(APP_PERMISSIONS.QuestionsCreate)],
    loadComponent: () =>
      import('./pages/create-question').then((m) => m.CreateQuestion),
  },
  {
    title: 'pagesTitles.questionEdit',
    path: APP_ROUTES.QUESTIONS_EDIT,
    canActivate: [permissionGuard(APP_PERMISSIONS.QuestionsUpdate)],
    loadComponent: () =>
      import('./pages/update-question').then((m) => m.UpdateQuestion),
  },
  {
    title: 'pagesTitles.questionDetail',
    path: APP_ROUTES.QUESTIONS_DETAIL,
    canActivate: [permissionGuard(APP_PERMISSIONS.QuestionsRead)],
    loadComponent: () =>
      import('./pages/show-question').then((m) => m.ShowQuestion),
  },
];
